/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class CertExamApplyCourseLog extends Ce {
    constructor() {
        super();
        this.baseUrl += '/certExamApplyCourseLog';
    }

    findCertExamApplyCourseLogList({
        fullName,
        mobile,
        idCardNo,
        certCatId,
        certExamType,
        groupingName,
        examApplyTime,
        endTime,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        let examApplyTimeBegin = null;
        let examApplyTimeEnd = null;
        if (examApplyTime != null && examApplyTime.length === 2) {
            [examApplyTimeBegin, examApplyTimeEnd] = examApplyTime;
        }
        let endTimeBegin = null;
        let endTimeEnd = null;
        if (endTime != null && endTime.length === 2) {
            [endTimeBegin, endTimeEnd] = endTime;
        }
        return super.get('/findCertExamApplyCourseLogList', {
            fullName,
            mobile,
            idCardNo,
            certCatId,
            certExamType,
            groupingName,
            examApplyTimeBegin,
            examApplyTimeEnd,
            endTimeBegin,
            endTimeEnd,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }
}

export default new CertExamApplyCourseLog();
export { CertExamApplyCourseLog };
